import React from 'react';
import { FilterSetController, Filter } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

const SearchModule = ({ ticket_office, displayData, filters, setFilters, loadingCount }) => {
    const { t } = useTranslation();

    //This filter is very rickety, it won't filter for the deleted operator, can be updated when we will have resolved
    // the firsts issues with the operators and cash_balance recuperation
    const operatorOptions = React.useMemo(() => {
        const base = [
            { key: 0, text: t('ticket.sales_report.account_organization'), name: 'Orga' } //Any string seems to work to get back our orga with partner_id 0
        ];

        const others = ticket_office.operators
            ? ticket_office.operators.map(o => ({
                  key: o.id,
                  text: o.name,
                  name: `${o.id}`
              }))
            : [];

        return [...base, ...others];
    }, [ticket_office, ticket_office.operators]);

    const statusOptions = React.useMemo(() => {
        return [
            {
                key: 'finish',
                text: t('ticket.sales_report.filter.finish'),
                name: 'finish'
            },
            {
                key: 'inProgress',
                text: t('ticket.sales_report.filter.inProgress'),
                name: 'inProgress'
            }
        ];
    }, []);

    const onChangeSearch = React.useCallback(
        value => {
            let tmpFilters = { ...filters };
            if (value !== '' && value !== null) {
                tmpFilters = { ...tmpFilters, search: value };
            } else {
                delete tmpFilters.search;
            }
            setFilters(tmpFilters);
        },
        [filters]
    );

    return (
        <FilterSetController
            total={displayData?.length}
            isLoadingTotal={!displayData || loadingCount}
            labelTotal={t('ticket.sales_report.sessions_sales_label_quantity', { count: displayData?.length })}
            labelReset={t('ticket.common.action.reset')}
            labelFilters={t('ticket.sales_report.filters')}
            initialValues={filters}
            search={{
                placeholder: t('ticket.common.action.search'),
                displayResetIcon: true,
                onChange: (synth, value) => {
                    onChangeSearch(value);
                },
                handleReset: () => {
                    onChangeSearch(null);
                },
                value: filters?.search || ''
            }}
            onChange={values => {
                if (filters.search !== undefined && filters.search.length > 0) {
                    values.search = filters.search;
                }
                setFilters(values);
            }}
        >
            <Filter
                name={'partner_id'}
                labelName={t('ticket.sales_report.filter.operator')}
                options={operatorOptions}
                index="1"
                labelCTA={t('ticket.common.action.search')}
                multiple
            />
            <Filter name={'filter_id'} labelName={t('ticket.sales_report.filter.type')} options={statusOptions} index="2" />
        </FilterSetController>
    );
};

export default SearchModule;
